import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'findByProp',
})
export class FindByPropPipe implements PipeTransform {
  transform<T>(propValue: any, list: T[], propName: string, multi = false): T[] {
    if (multi && Array.isArray(propValue)) {
      return propValue.map(val => list.find(i => i[propName] === val)).filter(Boolean) as T[];
    } else {
      const item = list.find(i => i[propName] === propValue);
      return item ? ([item] as T[]) : [];
    }
  }
}
